<template>
  <div class="DatePickerYears">
    <Button text severity="secondary" @click="pageLeft()">
      <i class="pi pi-chevron-left"></i>
    </Button>
    <div class="years">
      <div v-for="year in years" class="year" :class="{ selected: year == selectedYear }" @click="emit('yearSelected', year)">
        {{ year }}
      </div>
    </div>
    <Button text severity="secondary" @click="pageRight()">
      <i class="pi pi-chevron-right"></i>
    </Button>
  </div>  
</template>

<script setup>
import { computed, ref } from "vue";
import { watchImmediate } from "@vueuse/core";
import { range } from "./utility.js";


const props = defineProps([ "date" ]);
const emit = defineEmits([ "yearSelected" ]);

const dateOrNow = computed(() => props.date ?? new Date());

const yearShown = ref(null);
watchImmediate(dateOrNow, () => {
  yearShown.value = dateOrNow.value.getUTCFullYear();
});

const selectedYear = computed(() => props.date?.getUTCFullYear());
const years = computed(() => {
  let startYear = parseInt(yearShown.value / 10) * 10;
  let result = range(startYear, startYear + 12);
  return result;
});

function pageLeft() {
  yearShown.value -= 10;
}

function pageRight() {
  yearShown.value += 10;
}
</script>

<style scoped>
.DatePickerYears {
  display: flex;
  align-items: center;
}
.years {
  height: 440px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 1fr
}
.year {
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}
.year:hover {
  background: var(--gray-100);
}
.year.selected {
  border: 1px dotted var(--blue-100);
  background: var(--blue-50);
}
button {
  border: 0;
}
</style>